import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import ApplyProcessApi from 'api/curo/ApplyProcessApi';
import OneSpanSignApi from 'api/curo/OneSpanSignApi';
import SignInProcessApi from 'api/curo/SignInProcessApi';
import VerificationProcessApi from 'api/curo/VerificationProcessApi';

import { createBorrowerStateCheckThunk } from './createBorrowerStateCheckThunk';
import { createCheckExistingAccountThunk } from './createCheckExistingAccountThunk';
import { createCompleteSigningThunk } from './createCompleteSigningThunk';
import { createCreateAccountThunk } from './createCreateAccountThunk';
import { createCreateApplicationThunk } from './createCreateApplicationThunk';
import { createCreateBorrowerThunk } from './createCreateBorrowerThunk';
import { createExistingApplicationCheckThunk } from './createExistingApplicationCheckThunk';
import { createExistingBorrowerCheckThunk } from './createExistingBorrowerCheckThunk';
import { createGetCurrentAccountThunk } from './createGetCurrentAccountThunk';
import { createGetCurrentApplicationThunk } from './createGetCurrentApplicationThunk';
import { createGetPlaidLinkTokenThunk } from './createGetPlaidLinkTokenThunk';
import { createGetSigningUrlThunk } from './createGetSigningUrlThunk';
import { createGoogleAssessmentCheckThunk } from './createGoogleAssessmentCheckThunk';
import { createGpsGatewayCheckThunk } from './createGpsGatewayCheckThunk';
import { createHandleDeclineApplicationThunk } from './createHandleDeclineApplicationThunk';
import { createHandleDocumentsUploadedThunk } from './createHandleDocumentsUploadedThunk';
import { createHandleOrganicLoanOfferViewedThunk } from './createHandleOrganicLoanOfferViewedThunk';
import { createLogoutThunk } from './createLogoutThunk';
import { createOrganicCreditAndAutoOriginationCheckThunk } from './createOrganicCreditAndAutoOriginationCheckThunk';
import { createPlaidSavePublicTokenThunk } from './createPlaidSavePublicTokenThunk';
import { createRefiAutoOriginationCheckThunk } from './createRefiAutoOriginationCheckThunk';
import { createRefiCreditCheckThunk } from './createRefiCreditCheckThunk';
import { createRunApplicationSummitLeadThunk } from './createRunApplicationSummitLeadThunk';
import { createRunPreliminaryCheckThunk } from './createRunPreliminaryCheckThunk';
import { createRunSecondChanceCashflowAndAutoOriginationStrategyThunk } from './createRunSecondChanceCashflowAndAutoOriginationStrategyThunk';
import { createRunSnowflakeRefiReloanThunk } from './createRunSnowflakeRefiReloanThunk';
import { createRunSnowflakeRefiScoreThunk } from './createRunSnowflakeRefiScoreThunk';
import { createSaveAutoPayOptionThunk } from './createSaveAutoPayOptionThunk';
import { createSaveBankInformationThunk } from './createSaveBankInformationThunk';
import { createSaveIncomeSourcesThunk } from './createSaveIncomeSourcesThunk';
import { createSaveSelectedOfferThunk } from './createSaveSelectedOfferThunk';
import { createSaveTermsOfUseAcceptanceThunk } from './createSaveTermsOfUseAcceptanceThunk';
import { createSelectBankAccountThunk } from './createSelectBankAccountThunk';
import { createSendEmailVerificationCodeThunk } from './createSendEmailVerificationCodeThunk';
import { createSendPhoneVerificationCodeThunk } from './createSendPhoneVerificationCodeThunk';
import { createSendVerificationCodeThunk } from './createSendVerificationCodeThunk';
import { createSubmitMailOfferThunk } from './createSubmitMailOfferThunk';
import { createUpdateBorrowerThunk } from './createUpdateBorrowerThunk';
import { createUpdateCurrentApplicationThunk } from './createUpdateCurrentApplicationThunk';
import { createUpdatePageDisplayedTechnicalThunk } from './createUpdatePageDisplayedTechnicalThunk';
import { createUploadDocumentsThunk } from './createUploadDocumentsThunk';
import { createVerifyEmailVerificationCode } from './createVerifyEmailVerificationCode';
import { createVerifyPhoneVerificationCodeThunk } from './createVerifyPhoneVerificationCodeThunk';
import { createVerifySessionThunk } from './createVerifySessionThunk';
import { createVerifySignInCodeThunk } from './createVerifySignInCodeThunk';
import { createWellsFargoCheckThunk } from './createWellsFargoCheckThunk';

const applyProcessApi = new ApplyProcessApi();
const signInProcessApi = new SignInProcessApi();
const verificationProcessApi = new VerificationProcessApi();
const applicationProcessApi = new ApplicationProcessApi();
const oneSpanSignApi = new OneSpanSignApi();

// ApplyProcess
export const checkExistingApplication = createExistingApplicationCheckThunk(applyProcessApi);
export const submitMailOffer = createSubmitMailOfferThunk(applyProcessApi);
export const checkExistingBorrower = createExistingBorrowerCheckThunk(applyProcessApi);
export const createBorrower = createCreateBorrowerThunk(applyProcessApi);
export const updateBorrower = createUpdateBorrowerThunk(applyProcessApi);
export const createApplication = createCreateApplicationThunk(applyProcessApi);
export const checkExistingAccount = createCheckExistingAccountThunk(applyProcessApi);
export const createAccount = createCreateAccountThunk(applyProcessApi);
export const borrowerStateCheck = createBorrowerStateCheckThunk(applyProcessApi);
export const createGoogleAssessment = createGoogleAssessmentCheckThunk(applyProcessApi);

// SignInProcess
export const sendVerificationCode = createSendVerificationCodeThunk(signInProcessApi);
export const verifyCode = createVerifySignInCodeThunk(signInProcessApi);
export const verifySession = createVerifySessionThunk(signInProcessApi);
export const logout = createLogoutThunk(signInProcessApi);

// VerificationProcess
export const getCurrentAccount = createGetCurrentAccountThunk(verificationProcessApi);
export const sendEmailVerificationCode =
  createSendEmailVerificationCodeThunk(verificationProcessApi);
export const verifyEmailVerificationCode =
  createVerifyEmailVerificationCode(verificationProcessApi);
export const sendPhoneVerificationCode =
  createSendPhoneVerificationCodeThunk(verificationProcessApi);
export const verifyPhoneVerificationCode =
  createVerifyPhoneVerificationCodeThunk(verificationProcessApi);

//Application process
export const getCurrentApplication = createGetCurrentApplicationThunk(applicationProcessApi);
export const updateCurrentApplication = createUpdateCurrentApplicationThunk(applicationProcessApi);
export const saveIncomeSources = createSaveIncomeSourcesThunk(applicationProcessApi);
export const saveBankInformation = createSaveBankInformationThunk(applicationProcessApi);
export const selectBankAccount = createSelectBankAccountThunk(applicationProcessApi);
export const saveTermsOfUseAcceptance = createSaveTermsOfUseAcceptanceThunk(applicationProcessApi);
export const uploadDocuments = createUploadDocumentsThunk(applicationProcessApi);
export const handleDocumentsUploaded = createHandleDocumentsUploadedThunk(applicationProcessApi);
export const gpsGatewayCheck = createGpsGatewayCheckThunk(applicationProcessApi);
export const wellsFargoCheck = createWellsFargoCheckThunk(applicationProcessApi);
export const saveSelectedOffer = createSaveSelectedOfferThunk(applicationProcessApi);
export const organicCreditAndAutoOriginationCheck =
  createOrganicCreditAndAutoOriginationCheckThunk(applicationProcessApi);
export const refiCreditCheck =
  createRefiCreditCheckThunk(applicationProcessApi);
export const refiAutoOriginationCheck =
  createRefiAutoOriginationCheckThunk(applicationProcessApi);
export const getPlaidLinkToken = createGetPlaidLinkTokenThunk(applicationProcessApi);
export const plaidSavePublicToken = createPlaidSavePublicTokenThunk(applicationProcessApi);
export const getSigningUrl = createGetSigningUrlThunk(oneSpanSignApi);
export const completeSigning = createCompleteSigningThunk(oneSpanSignApi);
export const saveAutoPayOption = createSaveAutoPayOptionThunk(applicationProcessApi);
export const runSnowflakeRefiScore = createRunSnowflakeRefiScoreThunk(applicationProcessApi);
export const runSnowflakeRefiReloanScore = createRunSnowflakeRefiReloanThunk(applicationProcessApi);
export const updateOrganicLoanOfferViewed = createHandleOrganicLoanOfferViewedThunk(applicationProcessApi);
export const updatePageDisplayedTechnical = createUpdatePageDisplayedTechnicalThunk(applicationProcessApi);
export const runApplicationSummitLead = createRunApplicationSummitLeadThunk(applicationProcessApi);
export const runSecondChanceCashflowAndAutoOrigination = createRunSecondChanceCashflowAndAutoOriginationStrategyThunk(applicationProcessApi);
export const handleDeclineApplication = createHandleDeclineApplicationThunk(applicationProcessApi);
export const runPreliminaryCheck = createRunPreliminaryCheckThunk(applicationProcessApi);
